import Zoom from '@arcgis/core/widgets/Zoom';
import { createWidget } from '../../util/createWidget';

const ArcZoom = createWidget(
  Zoom
);

export { ArcZoom };
